import React from 'react';
import deepEqual from 'deep-equal';

import {hasValue} from '@famly/stat_ts-utils_has-value';
import Spinner from 'web-app/react/components/loading/spinner/spinner';
import {checkIfFlagIsToggled, DebugLocalStorageFlags} from 'web-app/react/routes/debugger/local-storage-config';

import {useInvoiceSummary} from '../../../hooks/use-invoice-summary';
import {InvoiceSummary} from './invoice-summary';
import type {PlanUpdate} from '../../../helpers/invoice-summary';
import {type InvoiceSummary as InvoiceSummaryType} from '../../../helpers/invoice-summary';

type Properties = {
    siteId: string;
    childId: string;
    updatedPlan: PlanUpdate | undefined;
};

const Loader = (properties: Properties) => {
    const enableProrate = React.useMemo(
        () => checkIfFlagIsToggled(DebugLocalStorageFlags.NEW_INVOICE_SUMMARY_PRORATE.flag),
        [],
    );
    // Don't clear the invoice summary until the next is loaded by showing `shownInvoiceSummary`. This is more attractive but also keeps scroll position.
    const [shownInvoiceSummary, setShownInvoiceSummary] = React.useState<InvoiceSummaryType | null>(null);
    const {invoiceSummary, isLoading} = useInvoiceSummary(
        properties.siteId,
        properties.childId,
        properties.updatedPlan,
    );
    React.useEffect(() => {
        if (!isLoading && !deepEqual(invoiceSummary, shownInvoiceSummary)) {
            setShownInvoiceSummary(invoiceSummary);
        }
    }, [isLoading, invoiceSummary, shownInvoiceSummary]);

    const invoiceSummaryNode = React.useMemo(() => {
        if (!hasValue(shownInvoiceSummary)) {
            return <Spinner centered margined />;
        }
        return (
            <InvoiceSummary
                invoiceSummary={shownInvoiceSummary}
                siteId={properties.siteId}
                enableProrate={enableProrate}
            />
        );
    }, [shownInvoiceSummary, properties.siteId, enableProrate]);
    return invoiceSummaryNode;
};

export {Loader as InvoiceSummary};
